export default {"src":"/_next/static/media/green-check.35a9af92.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};